/* ==========================================================================
   BODY WISE — PREMIUM VIP PACK
   One initialiser per section root. Re-runs on shopify:section:load so the
   theme editor keeps working when a merchant drags sections around.
   ========================================================================== */
(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('[data-vip-main-image]');
    var thumbs = root.querySelectorAll('[data-vip-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        // fall back to the thumb's own rendered image if the data attribute is empty
        var inner = t.querySelector('img');
        var src = t.dataset.vipThumb || (inner && (inner.currentSrc || inner.src)) || '';
        if (!src) return;

        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');

        var restore = function () { main.style.opacity = 1; };
        main.style.opacity = 0;
        main.addEventListener('load', restore, { once: true });
        main.addEventListener('error', restore, { once: true });
        main.removeAttribute('srcset');
        main.src = src;
        if (inner && inner.alt) main.alt = inner.alt;
        // safety net: a cached image can paint without firing load
        setTimeout(restore, 400);
      });
    });

    initThumbStrip(root);
  }

  // Thumbnail strip: every product image is in the DOM and the strip scrolls,
  // so nothing is dropped when a product has more media than fits on one row.
  function initThumbStrip(root) {
    var strip = root.querySelector('[data-vip-thumbs]');
    if (!strip) return;
    var track = strip.querySelector('[data-vip-thumbs-track]');
    var prev = strip.querySelector('[data-vip-thumbs-prev]');
    var next = strip.querySelector('[data-vip-thumbs-next]');
    if (!track) return;

    function overflowing() { return track.scrollWidth - track.clientWidth > 4; }

    function sync() {
      var can = overflowing();
      var x = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.hidden = !can || x <= 2;
      if (next) next.hidden = !can || x >= max - 2;
    }

    function page(dir) {
      var first = track.querySelector('.vip-thumb');
      var step = first ? (first.getBoundingClientRect().width + 10) : 90;
      var per = Math.max(1, Math.floor(track.clientWidth / step));
      track.scrollBy({ left: dir * step * per, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    // arrow keys move through the strip once a thumb has focus
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var list = Array.prototype.slice.call(track.querySelectorAll('.vip-thumb'));
      var i = list.indexOf(document.activeElement);
      if (i < 0) return;
      var n = list[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (!n) return;
      e.preventDefault();
      n.focus();
      n.click();
    });

    // keep the selected thumb visible when the main image changes
    track.addEventListener('click', function (e) {
      var t = e.target.closest('.vip-thumb');
      if (!t) return;
      var tl = t.offsetLeft, tr = tl + t.offsetWidth;
      if (tl < track.scrollLeft || tr > track.scrollLeft + track.clientWidth) {
        track.scrollTo({ left: tl - 8, behavior: 'smooth' });
      }
    });

    sync();
    // images load lazily, so widths settle after first paint
    window.addEventListener('load', sync);
    setTimeout(sync, 600);
  }

  // Click-to-enlarge. One overlay is shared by the page; it lists every product
  // image, opens on whichever one is showing, and syncs the main image on close
  // so the gallery and the lightbox never disagree.
  function initLightbox(root) {
    var frame = root.querySelector('[data-vip-zoom]');
    var main = root.querySelector('[data-vip-main-image]');
    if (!frame || !main) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vip-thumb]'));
    var shots = thumbs.length
      ? thumbs.map(function (t) {
          return { full: t.dataset.vipFull || t.dataset.vipThumb, alt: (t.querySelector('img') || {}).alt || '' };
        })
      : [{ full: main.dataset.vipFull || main.src, alt: main.alt }];

    var box, img, prev, next, count, lastFocus, i = 0;

    function build() {
      box = document.createElement('div');
      box.className = 'vip-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product image');
      box.innerHTML =
        '<button type="button" class="vip-lb__btn vip-lb__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
        '<figure class="vip-lb__fig">' +
          '<button type="button" class="vip-lb__btn vip-lb__prev" aria-label="Previous image">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
          '<img class="vip-lb__img" alt="">' +
          '<button type="button" class="vip-lb__btn vip-lb__next" aria-label="Next image">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>' +
        '</figure>' +
        '<span class="vip-lb__count"></span>';
      document.body.appendChild(box);

      img = box.querySelector('.vip-lb__img');
      prev = box.querySelector('.vip-lb__prev');
      next = box.querySelector('.vip-lb__next');
      count = box.querySelector('.vip-lb__count');

      box.querySelector('.vip-lb__close').addEventListener('click', close);
      prev.addEventListener('click', function () { go(i - 1); });
      next.addEventListener('click', function () { go(i + 1); });
      box.addEventListener('click', function (e) {
        if (e.target.closest('.vip-lb__btn')) return;      // buttons handle themselves
        if (!e.target.closest('.vip-lb__img')) close();    // anywhere else dismisses
      });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') go(i + 1);
        else if (e.key === 'ArrowLeft') go(i - 1);
      });

      // swipe on touch
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
    }

    function go(n) {
      if (n < 0) n = shots.length - 1;
      if (n >= shots.length) n = 0;
      i = n;
      img.src = shots[i].full;
      img.alt = shots[i].alt;
      count.textContent = shots.length > 1 ? (i + 1) + ' / ' + shots.length : '';
      prev.hidden = next.hidden = shots.length < 2;
    }

    function open() {
      if (!box) build();
      // start on whatever the gallery is currently showing
      var active = root.querySelector('[data-vip-thumb].is-active');
      go(active ? Math.max(0, thumbs.indexOf(active)) : 0);
      lastFocus = document.activeElement;
      document.body.classList.add('vip-lb-open');
      box.classList.add('is-open');
      box.querySelector('.vip-lb__close').focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.body.classList.remove('vip-lb-open');
      // leave the gallery on the image the shopper ended on
      var t = thumbs[i];
      if (t && !t.classList.contains('is-active')) t.click();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    frame.addEventListener('click', function (e) {
      if (e.target.closest('.vip-badge, .vip-stock')) return;
      open();
    });
    frame.setAttribute('tabindex', '0');
    frame.setAttribute('role', 'button');
    frame.setAttribute('aria-label', 'Enlarge product image');
    frame.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }

  function initBuyBox(root) {
    var opts = root.querySelectorAll('[data-vip-option]');
    var qty = root.querySelector('[data-vip-qty]');
    var btnLabel = root.querySelector('[data-vip-atc-label]');
    if (!opts.length && !qty) return;

    function currentUnit() {
      var sel = root.querySelector('[data-vip-option].is-sel');
      return sel ? parseFloat(sel.dataset.vipPrice || '0') : 0;
    }
    function sync() {
      if (!btnLabel) return;
      var unit = currentUnit();
      if (!unit) return;
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      if (qty) qty.value = q;
      btnLabel.textContent = btnLabel.dataset.vipAtcLabel + ' \u2014 ' +
        (root.dataset.vipCurrency || '$') + (unit * q / 100).toFixed(2);
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('is-sel'); });
        o.classList.add('is-sel');
        var input = o.querySelector('input');
        if (input) input.checked = true;
        var variantField = root.querySelector('[data-vip-variant-id]');
        if (variantField && o.dataset.vipVariant) variantField.value = o.dataset.vipVariant;
        sync();
      });
    });

    root.querySelectorAll('[data-vip-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.vipQtyStep, 10);
        if (parseInt(qty.value, 10) < 1) qty.value = 1;
        sync();
      });
    });
    if (qty) qty.addEventListener('change', sync);
    initVariants(root, sync);
    sync();
  }

  // Variant picker: chosen option values -> variant -> reprice every purchase row.
  function initVariants(root, sync) {
    var picker = root.querySelector('[data-vip-variant-picker]');
    var dataEl = root.querySelector('[data-vip-variants]');
    if (!picker || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cur = root.dataset.vipCurrency || '$';
    function fmt(c) { return cur + (c / 100).toFixed(2); }

    function chosen() {
      var vals = [];
      picker.querySelectorAll('input[data-vip-opt-index]:checked').forEach(function (i) {
        vals[+i.dataset.vipOptIndex] = i.value;
      });
      return vals;
    }
    function match(vals) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < vals.length; j++) if (variants[i].options[j] !== vals[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    function setRowPrice(row, now, was) {
      row.dataset.vipPrice = now;
      var b = row.querySelector('.vip-opt__price b');
      if (b) b.textContent = fmt(now);
      var s = row.querySelector('.vip-opt__price s');
      if (was > now) {
        if (!s) { s = document.createElement('s'); b.parentNode.appendChild(s); }
        s.textContent = fmt(was);
      } else if (s) {
        s.remove();
      }
    }
    function apply(v) {
      var idField = root.querySelector('[data-vip-variant-id]');
      if (idField) idField.value = v.id;

      var now = root.querySelector('[data-vip-price-now]');
      if (now) now.textContent = fmt(v.price);

      var one = root.querySelector('[data-vip-onetime]');
      if (one) {
        one.dataset.vipPrice = v.price;
        var ob = one.querySelector('.vip-opt__price b');
        if (ob) ob.textContent = fmt(v.price);
      }

      var firstVisible = null;
      root.querySelectorAll('[data-vip-plan]').forEach(function (row) {
        var plan = v.plans[row.dataset.vipPlan];
        row.hidden = !plan;
        if (plan) {
          setRowPrice(row, plan[0], plan[1]);
          if (!firstVisible) firstVisible = row;
        }
      });
      var sel = root.querySelector('[data-vip-option].is-sel');
      if (sel && sel.hidden && (firstVisible || one)) (firstVisible || one).click();

      if (v.image) {
        var img = root.querySelector('[data-vip-main-image]');
        if (img) img.src = v.image;
      }

      var atc = root.querySelector('[data-vip-atc]');
      var label = root.querySelector('[data-vip-atc-label]');
      if (atc) atc.disabled = !v.available;
      if (label && !v.available) label.textContent = 'Sold out';

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      // Sections outside the hero (the pack grid on kit pages) follow this.
      try {
        document.dispatchEvent(new CustomEvent('vip:variant', { detail: { id: v.id } }));
      } catch (e) {}
      if (v.available) sync();
    }
    function refreshPills(vals) {
      picker.querySelectorAll('input[data-vip-opt-index]').forEach(function (i) {
        var idx = +i.dataset.vipOptIndex;
        var test = vals.slice(); test[idx] = i.value;
        var m = match(test);
        var pill = i.closest('.vip-variants__pill');
        if (!pill) return;
        pill.classList.toggle('is-sel', i.checked);
        pill.classList.toggle('is-unavail', !m || !m.available);
      });
      picker.querySelectorAll('.vip-variants__group').forEach(function (g) {
        var c = g.querySelector('input:checked');
        var l = g.querySelector('[data-vip-opt-label]');
        if (c && l) l.textContent = c.value;
      });
    }

    picker.addEventListener('change', function () {
      var vals = chosen();
      refreshPills(vals);
      var v = match(vals);
      if (v) apply(v);
    });
    refreshPills(chosen());
  }

  // Automatic recommendations: the Product Recommendations API returns this same
  // section rendered with results, so we graft its inner markup in and re-init.
  function initRecs(root) {
    var box = root.querySelector('[data-vip-recs]');
    if (!box || !box.dataset.url || box.dataset.vipRecsDone) return;
    box.dataset.vipRecsDone = '1';
    fetch(box.dataset.url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vip-recs]');
        if (!fresh || !fresh.innerHTML.trim()) return;
        box.innerHTML = fresh.innerHTML;
        initReveal(root);
        initQuickAdd(root);
      })
      .catch(function () { /* leave the section empty rather than showing a broken state */ });
  }

  // Quick add from a recommendation card.
  function initQuickAdd(root) {
    var forms = root.querySelectorAll('.vip-rec__form');
    if (!forms.length) return;
    var after = root.dataset.vipAfterAdd || 'stay';

    forms.forEach(function (form) {
      if (form.dataset.vipQaBound) return;
      form.dataset.vipQaBound = '1';
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.dataset.busy) return;
        e.preventDefault();
        btn.dataset.busy = '1';
        var label = btn.dataset.vipQaLabel || btn.textContent.trim();
        btn.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            if (after === 'cart') { window.location.href = '/cart'; return; }
            if (after === 'reload') { window.location.reload(); return; }
            btn.textContent = 'Added \u2713';
            btn.classList.add('is-added');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            setTimeout(function () {
              btn.textContent = label;
              btn.classList.remove('is-added');
              delete btn.dataset.busy;
            }, 2200);
          })
          .catch(function () {
            delete btn.dataset.busy;
            btn.textContent = label;
            form.submit();
          });
      });
    });
  }

  // The buy box posts the add itself.
  //
  // Subscription apps (Appstle here) attach their own submit handler to the
  // product form and rewrite selling_plan from the state of *their* widget —
  // which this section hides — so a chosen plan arrived at the cart as one-time.
  // Listening on document in the capture phase means we run before any handler
  // bound to the form, and stopPropagation keeps the event from reaching them.
  // The payload is built from our own fields, so nothing else can alter it.
  function initProductForm(root) {
    var form = root.querySelector('#vip-product-form');
    if (!form || form.dataset.vipBound) return;
    form.dataset.vipBound = '1';
    var after = root.dataset.vipAfterAdd || 'cart';

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();

      var btn = form.querySelector('[data-vip-atc]');
      var label = form.querySelector('[data-vip-atc-label]');
      var text = label ? label.textContent : '';
      var idEl = form.querySelector('[data-vip-variant-id]');
      var qtyEl = form.querySelector('[data-vip-qty]');
      var plan = form.querySelector('.vip-opts input[name="selling_plan"]:checked');

      if (!idEl || !idEl.value) return;
      var body = {
        items: [{
          id: Number(idEl.value),
          quantity: qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1
        }]
      };
      if (plan && plan.value) body.items[0].selling_plan = Number(plan.value);

      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (d) { return Promise.reject(d); }); })
        .then(function () {
          if (after === 'reload') { window.location.reload(); return; }
          if (after === 'stay') {
            if (btn) btn.disabled = false;
            if (label) {
              label.textContent = 'Added ✓';
              setTimeout(function () { label.textContent = text; }, 2200);
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          if (btn) btn.disabled = false;
          if (label) label.textContent = (err && err.description) ? err.description : text;
          if (label && err && err.description) {
            setTimeout(function () { label.textContent = text; }, 3000);
          }
        });
    }, true);
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-vip-faq-item]');
    if (!items.length) return;
    items.forEach(function (item) {
      var a = item.querySelector('[data-vip-faq-answer]');
      var q = item.querySelector('[data-vip-faq-question]');
      if (!a || !q) return;
      if (item.classList.contains('is-open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        // single-open by default; sections can opt into leaving several open
        if (root.dataset.vipFaqMulti !== 'true') {
          items.forEach(function (i) {
            if (i === item) return;
            i.classList.remove('is-open');
            var ia = i.querySelector('[data-vip-faq-answer]');
            if (ia) ia.style.maxHeight = null;
          });
        }
        if (open) {
          item.classList.remove('is-open');
          a.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.vip-rv');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });

    // Failsafes. A reveal that never fires would leave a whole section blank, so
    // anything already near the viewport shows on load and everything is forced
    // visible shortly after, whatever the observer does.
    var showAll = function () { els.forEach(function (el) { el.classList.add('is-in'); }); };
    window.addEventListener('load', function () {
      var vh = window.innerHeight || 0;
      els.forEach(function (el) {
        if (!vh || el.getBoundingClientRect().top < vh + 200) el.classList.add('is-in');
      });
    });
    setTimeout(showAll, 4000);
  }

  function initRing(root) {
    var ring = root.querySelector('[data-vip-ring]');
    if (!ring) return;
    var pct = parseInt(ring.dataset.vipRing, 10);
    if (!isNaN(pct)) ring.style.setProperty('--ring-offset', (722 - (722 * pct / 100)) + '');
    if (!('IntersectionObserver' in window)) { ring.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { ring.classList.add('is-on'); io.unobserve(ring); } });
    }, { threshold: 0.4 });
    io.observe(ring);
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-vip-sticky]');
    if (!bar) return;
    var anchor = document.querySelector(bar.dataset.vipStickyAfter || '#vip-buy');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
    }, { threshold: 0, rootMargin: '-120px 0px 0px 0px' });
    io.observe(anchor);
  }

  function initParallax(root) {
    var items = root.querySelectorAll('[data-vip-parallax]');
    if (!items.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (window.innerWidth < 750) {
        items.forEach(function (el) { el.style.transform = ''; });
        return;
      }
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) return;
        var strength = parseFloat(el.dataset.vipParallax || '0');
        if (!strength) return;
        // -1 when the element sits below the fold, +1 when it has scrolled past
        var progress = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        if (progress < -1) progress = -1;
        if (progress > 1) progress = 1;
        el.style.transform = 'translate3d(0,' + (progress * -strength).toFixed(2) + 'px,0)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initVideoReviews(root) {
    var track = root.querySelector('[data-vip-vr-track]');
    if (!track) return;
    var cards = track.querySelectorAll('.vip-vr__card');
    var autoplay = root.dataset.vipVrAutoplay !== 'false';
    var active = null;

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
    });

    function stop(card) {
      var v = card.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.controls = false;
      card.classList.remove('is-playing');
      if (!autoplay) v.pause();
    }

    // one review with sound at a time; tap again to pause
    cards.forEach(function (card) {
      var media = card.querySelector('[data-vip-vr-media]');
      var v = card.querySelector('video');
      if (!media || !v) return;
      media.addEventListener('click', function (e) {
        if (e.target.closest('video') && v.controls) return; // let native controls work
        if (active === card && !v.paused && !v.muted) {
          v.pause();
          card.classList.remove('is-playing');
          active = null;
          return;
        }
        cards.forEach(function (c) { if (c !== card) stop(c); });
        v.muted = false;
        v.currentTime = 0;
        v.controls = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
        active = card;
      });
    });

    // muted previews only while visible, so off-screen videos don't burn bandwidth
    if (autoplay && 'IntersectionObserver' in window &&
        !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var card = en.target;
          var v = card.querySelector('video');
          if (!v || card === active) return;
          if (en.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }

    var prev = root.querySelector('[data-vip-vr-prev]');
    var next = root.querySelector('[data-vip-vr-next]');
    function step(dir) {
      var first = cards[0];
      var w = first ? first.getBoundingClientRect().width + 18 : 300;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* Apps like Appstle Subscriptions inject a widget into every product form via
     an app embed. The hero has its own one-time/subscription selector, so a second
     widget duplicates it — and its hidden selling_plan input would still submit
     and could override the customer's choice. Remove, don't just hide. */
  function initAppGuard(root) {
    if (root.getAttribute('data-vip-hide-apps') !== 'true') return;
    var form = root.querySelector('#vip-product-form');

    function clean() {
      root.querySelectorAll('[class*="appstle"],[id*="appstle"]').forEach(function (el) { el.remove(); });
      if (!form) return;
      Array.prototype.slice.call(form.children).forEach(function (el) {
        if (el.matches('.vip-opts, .vip-qty-row')) return;
        if (el.tagName === 'INPUT' && el.type === 'hidden' && el.name !== 'selling_plan') return;
        el.remove();
      });
      var row = form.querySelector('.vip-qty-row');
      if (row) {
        Array.prototype.slice.call(row.children).forEach(function (el) {
          if (el.matches('.vip-qty, button[name="add"]')) return;
          el.remove();
        });
      }
      // any selling_plan field that isn't one of our radios
      form.querySelectorAll('[name="selling_plan"]').forEach(function (inp) {
        if (!inp.closest('.vip-opts')) inp.remove();
      });
    }

    clean();
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        (window.requestAnimationFrame || setTimeout)(function () { pending = false; clean(); });
      }).observe(root, { childList: true, subtree: true });
    }
  }

  // About hero collage: layered drift.
  //
  // Two inputs feed one transform per layer — how far the section has scrolled
  // through the viewport, and where the cursor sits inside it. Each layer scales
  // both by its own depth, which is what makes the stack feel three-dimensional.
  // Values are eased toward their target in a single rAF loop, so a fast mouse
  // does not make the images snap.
  function initAboutHero(root) {
    // any section can opt into the collage motion with data-about-motion
    if (!root.hasAttribute('data-about-hero') && !root.hasAttribute('data-about-motion')) return;
    var layers = root.querySelectorAll('[data-about-img]');
    if (!layers.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var fine = !window.matchMedia || window.matchMedia('(pointer: fine)').matches;
    var useCursor = root.dataset.aboutCursor !== 'false' && fine;
    var useScroll = root.dataset.aboutParallax !== 'false';
    if (!useCursor && !useScroll) return;

    var strength = (parseFloat(root.dataset.aboutStrength) || 100) / 100;
    var CURSOR_MAX = 26;   // px a depth-100 layer travels at the edge of the section
    var SCROLL_MAX = 60;   // px a depth-100 layer travels across the whole scroll

    var target = { cx: 0, cy: 0, sy: 0 };
    var now = { cx: 0, cy: 0, sy: 0 };
    var running = false;

    function frame() {
      var moving = false;
      ['cx', 'cy', 'sy'].forEach(function (k) {
        var d = target[k] - now[k];
        if (Math.abs(d) > 0.05) { now[k] += d * 0.12; moving = true; }
        else { now[k] = target[k]; }
      });

      layers.forEach(function (el) {
        var depth = (parseFloat(el.dataset.depth) || 0) / 100 * strength;
        if (!depth) return;
        var x = now.cx * CURSOR_MAX * depth;
        var y = now.cy * CURSOR_MAX * depth + now.sy * SCROLL_MAX * depth;
        el.style.setProperty('--mx', x.toFixed(2) + 'px');
        el.style.setProperty('--my', y.toFixed(2) + 'px');
      });

      running = moving;
      if (moving) requestAnimationFrame(frame);
    }
    function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }

    if (useCursor) {
      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect();
        if (!r.width || !r.height) return;
        // -1 .. 1 from the centre of the section
        target.cx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        target.cy = ((e.clientY - r.top) / r.height - 0.5) * 2;
        kick();
      });
      root.addEventListener('mouseleave', function () {
        target.cx = 0; target.cy = 0; kick();
      });
    }

    if (useScroll) {
      var onScroll = function () {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.bottom < -200 || r.top > vh + 200) return;
        // -1 entering from below .. 1 leaving above
        target.sy = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2) * -1;
        if (target.sy < -1) target.sy = -1;
        if (target.sy > 1) target.sy = 1;
        kick();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  // Stat bar: count the figures up once, the first time the bar is in view.
  //
  // Only the numeric run is animated. "$4B" keeps its symbol, "1M+" keeps both,
  // "2,000" keeps its separators, and a figure with no digits at all ("Ongoing")
  // is left exactly as the merchant typed it.
  function initStatBar(root) {
    if (!root.hasAttribute('data-vip-countbar')) return;
    var vals = root.querySelectorAll('[data-vip-count-to]');
    if (!vals.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var parse = function (raw) {
      var m = String(raw).match(/^(\D*?)([\d][\d.,]*)(.*)$/);
      if (!m) return null;
      var digits = m[2];
      var n = parseFloat(digits.replace(/,/g, ''));
      if (isNaN(n)) return null;
      var decimals = (digits.split('.')[1] || '').length;
      return { pre: m[1], n: n, post: m[3], grouped: digits.indexOf(',') > -1, decimals: decimals };
    };

    var render = function (p, v) {
      var s = p.decimals ? v.toFixed(p.decimals) : String(Math.round(v));
      if (p.grouped) s = Number(s).toLocaleString('en-US', {
        minimumFractionDigits: p.decimals, maximumFractionDigits: p.decimals
      });
      return p.pre + s + p.post;
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var raw = el.getAttribute('data-vip-count-to') || el.textContent;
        var p = parse(raw);
        if (!p) return;                       // no digits: leave the text alone
        var t0 = null, dur = 1200;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = render(p, p.n * eased);
          if (k < 1) requestAnimationFrame(step);
          else el.textContent = raw;   // land exactly on what was typed
        };
        // start from zero so the growth is visible
        el.textContent = render(p, 0);
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    vals.forEach(function (el) { io.observe(el); });
  }

  function initBioToggle(root) {
    var wraps = root.querySelectorAll('[data-abd-bio]');
    if (!wraps.length) return;

    function sync(wrap) {
      var text = wrap.querySelector('[data-abd-bio-text]');
      var btn = wrap.querySelector('[data-abd-bio-toggle]');
      if (!text || !btn) return;
      if (wrap.classList.contains('is-open')) return;   // already expanded, leave it
      // one pixel of slack: sub-pixel line heights round the wrong way
      var clipped = text.scrollHeight - text.clientHeight > 1;
      btn.hidden = !clipped;
    }

    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('[data-abd-bio-toggle]');
      if (!btn) return;
      sync(wrap);

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var more = btn.querySelector('[data-abd-bio-more]');
        var less = btn.querySelector('[data-abd-bio-less]');
        if (more) more.hidden = open;
        if (less) less.hidden = !open;
      });
    });

    // fonts landing late change where the clamp falls, so measure again after
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { wraps.forEach(sync); });
    }
    window.addEventListener('resize', function () { wraps.forEach(sync); }, { passive: true });
  }

  function initRail(root) {
    // data-vrail sits on the section element, which is the root itself — and
    // querySelectorAll never matches its own context node, so add it by hand.
    var rails = Array.prototype.slice.call(root.querySelectorAll('[data-vrail]'));
    if (root.hasAttribute && root.hasAttribute('data-vrail')) rails.unshift(root);
    if (!rails.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    rails.forEach(function (rail) {
      var vp = rail.querySelector('[data-vrail-vp]');
      var group = rail.querySelector('[data-vrail-group]');
      if (!vp || !group) return;

      var wrap = rail.getAttribute('data-vrail-wrap') !== 'false';
      var GROUP = 0, STEP = 0;

      // A boolean "is animating" flag cleared only by the rAF loop sticks on
      // forever if the tab is backgrounded mid-glide, because rAF stops firing —
      // and every later click is then ignored. A deadline heals itself instead.
      var animUntil = 0;
      function animating() { return performance.now() < animUntil; }

      function measure() {
        var card = group.querySelector('.vrail__card');
        if (!card) return;
        GROUP = group.getBoundingClientRect().width;   // includes its trailing gap
        STEP = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(group).columnGap) || 0);
        if (wrap && GROUP > 0) vp.scrollLeft = GROUP;  // park on the middle copy
      }

      // The three groups are identical, so moving the scroll position by exactly
      // one group width cannot be seen. That is the whole trick: there is no end.
      function normalise() {
        if (!wrap || animating() || !GROUP) return;
        var x = vp.scrollLeft;
        if (x < GROUP * 0.5) vp.scrollLeft = x + GROUP;
        else if (x > GROUP * 1.5) vp.scrollLeft = x - GROUP;
      }

      function go(dir) {
        if (!STEP) measure();
        if (animating()) return;
        var delta = dir * STEP;
        if (reduce || document.hidden) { vp.scrollLeft += delta; normalise(); return; }
        var start = vp.scrollLeft, t0 = performance.now(), dur = 430, target = start + delta;
        animUntil = t0 + dur;
        (function frame(now) {
          // if the tab went away mid-glide, land on the target and stop
          if (document.hidden) { vp.scrollLeft = target; animUntil = 0; normalise(); return; }
          var p = Math.min(1, (now - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          vp.scrollLeft = start + delta * e;
          if (p < 1) requestAnimationFrame(frame);
          else { animUntil = 0; normalise(); }
        })(performance.now());
      }

      vp.addEventListener('scroll', normalise, { passive: true });
      vp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });

      var prev = rail.querySelector('[data-vrail-prev]');
      var next = rail.querySelector('[data-vrail-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      measure();
      window.addEventListener('resize', measure, { passive: true });
      // webfonts land after first paint and change the card height, not its width,
      // but the gap is read from computed style, so re-measure to be safe
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  function initCompare(root) {
    var stacks = root.querySelectorAll('[data-pfi2-stack]');
    if (!stacks.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    stacks.forEach(function (stack) {
      // a deadline rather than a boolean: a flag cleared by a timer that never
      // runs (backgrounded tab) would wedge the stack shut for good
      var busyUntil = 0;

      function swap() {
        if (stack.classList.contains('is-m')) {
          stack.classList.remove('is-m'); stack.classList.add('is-n');
        } else {
          stack.classList.remove('is-n'); stack.classList.add('is-m');
        }
      }

      function toggle() {
        if (performance.now() < busyUntil) return;
        if (reduce) { swap(); return; }
        busyUntil = performance.now() + 880;
        stack.classList.add('is-pulling');           // 1) pull the cards apart
        setTimeout(function () {
          stack.classList.remove('is-pulling');
          swap();                                     // 2) trade their places
        }, 260);
      }

      var hitboxes = stack.parentNode.querySelectorAll('[data-pfi2-toggle]');
      hitboxes.forEach(function (el) {
        el.addEventListener('click', toggle);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      });
    });
  }

  function initEarnings(root) {
    var card = root.querySelector('[data-vearn]');
    if (!card) return;
    var q = function (sel) { return card.querySelector(sel); };

    var inputs = {
      inv: q('[data-vearn-inv]'), team: q('[data-vearn-team]'),
      deep: q('[data-vearn-deep]'), avg: q('[data-vearn-avg]')
    };
    if (!inputs.inv || !inputs.team || !inputs.deep || !inputs.avg) return;

    // Rates come from the section settings so the maths stays editable in the
    // theme rather than being pinned in the script.
    var L1 = parseFloat(card.getAttribute('data-rate-l1')) || 20;
    var L23 = parseFloat(card.getAttribute('data-rate-l23')) || 10;
    var STEP = parseFloat(card.getAttribute('data-royalty-step')) || 10000;
    var MAXR = parseFloat(card.getAttribute('data-royalty-max')) || 5;

    function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

    function set(sel, text) { var el = q(sel); if (el) el.textContent = text; }

    function update() {
      var inv = Number(inputs.inv.value), team = Number(inputs.team.value);
      var deep = Number(inputs.deep.value), avg = Number(inputs.avg.value);

      set('[data-vearn-v-inv]', inv);
      set('[data-vearn-v-team]', team);
      set('[data-vearn-v-deep]', deep);
      set('[data-vearn-v-avg]', avg);

      var bonus = (inv * avg * L1 / 100) + (team * avg * L23 / 100);
      var l13 = (inv + team) * avg;
      var l4 = deep * avg;
      var rate = Math.min(MAXR, Math.floor(l13 / STEP));
      var royalty = l4 * rate / 100;
      var total = bonus + royalty;

      set('[data-vearn-o-aff]', money(bonus));
      set('[data-vearn-o-roy]', money(royalty));
      set('[data-vearn-o-rate]', rate + '%');
      set('[data-vearn-o-roylab]', 'Levels 1\u20133 sales ' + money(l13) +
        (rate === 0 ? ' \u2014 ' + money(STEP) + ' needed to qualify' : ' \u2014 qualified'));
      set('[data-vearn-o-total]', money(total));
      set('[data-vearn-o-year]', '\u2248 ' + money(total * 12) + ' a year');
    }

    Object.keys(inputs).forEach(function (k) {
      inputs[k].addEventListener('input', update);
    });
    update();
  }

  function initComingSoon(root) {
    var stages = root.querySelectorAll('[data-soon]');
    if (!stages.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) return;

    // A looping background video is exactly the kind of motion a reduced-motion
    // request is about, and CSS cannot stop it. Pause it and expose the controls
    // so the visitor can start it themselves if they want to.
    stages.forEach(function (stage) {
      var video = stage.querySelector('video');
      if (!video) return;
      video.autoplay = false;
      video.loop = false;
      try { video.pause(); } catch (e) {}
      video.controls = true;
      stage.classList.add('soon--controls');
    });
  }

  function initSection(root) {
    if (!root || root.dataset.vipReady === '1') return;
    root.dataset.vipReady = '1';
    // Each one runs in isolation: a failure in any single feature must never
    // stop the ones after it — initReveal in particular, since everything it
    // handles starts at opacity 0 and would otherwise stay invisible.

  // Kit pages render one pack grid per variant; the hero's picker fires
  // "vip:variant" and this shows the matching one. Products with a single
  // pack have no [data-vip-pack-variant] wrappers and this does nothing.
  function initPackSwap(root) {
    var grids = root.querySelectorAll('[data-vip-pack-variant]');
    if (!grids.length || root.vipPackBound) return;
    root.vipPackBound = true;
    function show(id) {
      var want = String(id), found = false;
      Array.prototype.forEach.call(grids, function (g) {
        var on = g.getAttribute('data-vip-pack-variant') === want;
        g.hidden = !on;
        if (on) found = true;
      });
      if (!found) grids[0].hidden = false;
    }
    document.addEventListener('vip:variant', function (e) {
      if (e && e.detail && e.detail.id) show(e.detail.id);
    });
  }



  // Gradient carousel: the incoming gradient wipes in from the left while the
  // product and copy cross-fade. Pauses off-screen, on hover and when the tab
  // is hidden, so a background tab is not running a timer for nothing.
  function initGradientHero(root) {
    var stages = root.querySelectorAll('[data-gh]');
    if (root.hasAttribute && root.hasAttribute('data-gh')) {
      stages = Array.prototype.slice.call(stages);
      stages.unshift(root);
    }
    if (!stages.length) return;

    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.ghBound) return;
      stage.dataset.ghBound = '1';

      var bgs    = stage.querySelectorAll('[data-gh-bg]');
      var shots  = stage.querySelectorAll('[data-gh-shot]');
      var panels = stage.querySelectorAll('[data-gh-panel]');
      var dots   = stage.querySelectorAll('[data-gh-dot]');
      var n = bgs.length;
      if (n < 2) return;

      var cur = 0;
      var busy = false;
      var timer = null;
      var visible = true;
      var hovered = false;
      var auto = stage.getAttribute('data-gh-autoplay') === '1';
      var gap = parseInt(stage.getAttribute('data-gh-interval'), 10) || 6000;
      var reduce = window.matchMedia &&
                   window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // One deterministic place where the resting state is written. Every
      // class is toggled from the same index, so an autoplay tick landing on
      // top of a click can never leave the gradient on one slide and the
      // product on another.
      function render(i) {
        Array.prototype.forEach.call(bgs, function (b, k) {
          b.classList.toggle('is-base', k === i);
          b.classList.remove('is-wipe');
        });
        Array.prototype.forEach.call(shots, function (x, k) {
          x.classList.toggle('is-on', k === i);
        });
        Array.prototype.forEach.call(panels, function (x, k) {
          x.classList.toggle('is-on', k === i);
        });
        Array.prototype.forEach.call(dots, function (d, k) {
          d.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        cur = i;
      }

      function show(next) {
        if (busy || next === cur || next < 0 || next >= n) return;
        busy = true;

        var incoming = bgs[next];
        incoming.classList.remove('is-base');
        // force a frame at the clipped start so the wipe actually plays
        void incoming.offsetWidth;
        incoming.classList.add('is-wipe');

        // the foreground crosses over while the gradient wipes
        Array.prototype.forEach.call(shots, function (x, k) {
          x.classList.toggle('is-on', k === next);
        });
        Array.prototype.forEach.call(panels, function (x, k) {
          x.classList.toggle('is-on', k === next);
        });
        Array.prototype.forEach.call(dots, function (d, k) {
          d.setAttribute('aria-current', k === next ? 'true' : 'false');
        });

        var done = false;
        var settle = function () {
          if (done) return;
          done = true;
          render(next);
          busy = false;
        };
        incoming.addEventListener('animationend', settle, { once: true });
        // an animation that never fires would wedge the carousel, so land it
        // on a deadline too — derived from the real duration, or a slow wipe
        // would be cut short by a fixed one
        var dur = parseFloat(getComputedStyle(incoming).animationDuration) || 0.72;
        setTimeout(settle, reduce ? 40 : (dur * 1000) + 400);
      }

      function next() { show((cur + 1) % n); }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (!auto || !visible || hovered || document.hidden) return;
        timer = setInterval(next, Math.max(2000, gap));
      }

      Array.prototype.forEach.call(dots, function (d, k) {
        d.addEventListener('click', function () { show(k); start(); });
      });

      stage.addEventListener('mouseenter', function () { hovered = true; stop(); });
      stage.addEventListener('mouseleave', function () { hovered = false; start(); });
      document.addEventListener('visibilitychange', start);

      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          start();
        }, { threshold: 0.2 }).observe(stage);
      }
      start();
    });
  }


    [initGallery, initLightbox, initBuyBox, initProductForm, initRecs, initQuickAdd,
     initFaq, initReveal, initRing, initSticky, initParallax, initVideoReviews,
     initAppGuard, initAboutHero, initStatBar, initBioToggle, initRail, initCompare,
     initEarnings, initComingSoon, initPackSwap, initGradientHero].forEach(function (fn) {
      try { fn(root); }
      catch (e) { if (window.console && console.error) console.error('[vip] ' + fn.name + ':', e); }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vip-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-vip-section]').forEach(function (r) {
      r.dataset.vipReady = '';
      initSection(r);
    });
  });
})();
